import { createRef, useRef, useState } from "react";
import { PredefinedParams } from "../../../../components/slidingpanel/type";
import NetworkFormProvider from "./context/NetworkFormProvider";
import NetworkCreateContent from "./NetworkCreateContent";

type NetworkCreateProps = {
  predefined_params?: PredefinedParams;
  createAnother: boolean;
  changeCreateAnother: () => void;
};

const NetworkCreate = ({
  predefined_params,
  createAnother,
  changeCreateAnother,
}: NetworkCreateProps) => {
  const nameRef = useRef<HTMLElement | null>(null);
  const regionRef = useRef<HTMLElement | null>(null);
  const [subnetRefs, setSubnetRefs] = useState<
    React.RefObject<HTMLDivElement>[]
  >([createRef()]);

  return (
    <NetworkFormProvider
      nameRef={nameRef}
      regionRef={regionRef}
      subnetRefs={subnetRefs}
      setSubnetRefs={setSubnetRefs}
      predefined_params={predefined_params}
    >
      <NetworkCreateContent
        createAnother={createAnother}
        changeCreateAnother={changeCreateAnother}
      />
    </NetworkFormProvider>
  );
};

export default NetworkCreate;
